var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{attrs:{"disabled":_vm.disabled,"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._t("title")],2),_c('v-expansion-panel-content',[_vm._t("cont")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }